import Button from "../../base/Button";

const renderIcon = (color) => (
    <svg width="26px" height="17px" viewBox="0 0 26 17" version="1.1">
        <title>align-center-vertical</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Lightsmap-2.0"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
        >
            <g
                id="Select-Manual"
                transform="translate(-480.000000, -73.000000)"
                stroke={color}
            >
                <g id="toolbar" transform="translate(0.000000, 60.000000)">
                    <g
                        id="Group-7"
                        transform="translate(457.400000, 13.500000)"
                    >
                        <g
                            id="align-center-vertical"
                            transform="translate(23.263071, 0.000000)"
                        >
                            <path d="M3.78947368,8 L0.421052632,8" id="Shape" />
                            <path d="M14.7368421,8 L9.68421053,8" id="Shape" />
                            <path d="M24,8 L20.6315789,8" id="Shape" />
                            <rect
                                id="Rectangle-path"
                                x="3.78947368"
                                y="0.421052632"
                                width="5.89473684"
                                height="15.1578947"
                            />
                            <rect
                                id="Rectangle-path"
                                x="14.7368421"
                                y="3.78947368"
                                width="5.89473684"
                                height="8.42105263"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * Toolbar button for aligning selected lights to the vertical middle.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered align middle button.
 */
const AlignMiddleButton = (props) => (
    <Button {...props} renderIcon={renderIcon} />
);

export default AlignMiddleButton;
